import { BoxProps, Grid, SimpleGrid } from '@mantine/core'

import { QuotationCard, QuotationItem } from 'components/molecules/quoteCard'
import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'
import { CarouselOrListingBlockWrapper } from '../carouselOrListingBlockWrapper'
import SectionWrapper from '../sectionWrapper'

type Props = {
  data: QuotationItem[]
  // wrapperProps?: SectionWrapperProps
  wrapperProps?: any
  color?: string
} & BoxProps

export const Quotations = ({
  data = [],
  wrapperProps,
  className,
  classNames,
  styles,
  color,
  ...rest
}: Props) => {
  const { theme } = useStyles(undefined, {
    name: 'ServiceConnections__Quotations',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  const { title, description } = wrapperProps
  return data.length > 0 ? (
    <SectionWrapper
      layout="withIcon"
      {...wrapperProps}
      {...rest}
      bgColor={theme.colors.neutral[0]}
      styles={{
        header: {
          [theme.fn.largerThan('sm')]: {
            ...(data.length === 1 &&
              (title || description) && {
                width: 456,
                flexShrink: 0,
              }),
          },
        },
        innerClass: {
          [theme.fn.largerThan('sm')]: {
            ...(data.length === 1 && {
              flexDirection: 'row',
              gap: 32,
            }),
          },
        },
      }}
    >
      <CarouselOrListingBlockWrapper
        lengthToCarouselDesktop={2}
        showFullSlide={!isMobile}
        percentOfEndSlideMobile={87}
        carouselSetting={{
          loop: false,
          withIndicators: false,
          ...(isMobile && {
            slideGap: 0,
          }),
          // withControls: ,
        }}
      >
        <CarouselOrListingBlockWrapper.Slider
          styles={{
            carouselViewport: {
              [theme.fn.smallerThan('sm')]: {
                '&:before, &:after': {
                  boxShadow: 'none !important',
                },
              },
            },
            progressRoot: {
              [theme.fn.smallerThan('sm')]: {
                marginTop: 0,
              },
            },
            sliderWrapper: {
              padding: '24px 10px 24px 5px',
              [theme.fn.largerThan('sm')]: {
                padding: '24px 16px',
              },
            },
          }}
        >
          {isMobile ? (
            data.map((i, idx) => (
              <QuotationCard iconColor={color} key={idx} {...i} />
            ))
          ) : data.length > 3 ? (
            [...new Array(Math.ceil(data.length / 6))].map((_i, idx) => (
              <SimpleGrid key={idx} spacing={24} cols={3}>
                {data.slice(6 * idx, 6 * idx + 6).map((j, jdx) => (
                  <QuotationCard iconColor={color} key={jdx} {...j} />
                ))}
              </SimpleGrid>
            ))
          ) : (
            <Grid gutter={24} grow>
              {data.map((j, jdx) => (
                <Grid.Col span={4} key={jdx}>
                  <QuotationCard iconColor={color} {...j} />
                </Grid.Col>
              ))}
            </Grid>
          )}
        </CarouselOrListingBlockWrapper.Slider>
      </CarouselOrListingBlockWrapper>
    </SectionWrapper>
  ) : null
}
